// Email-first verification: signup / login go email code -> phone OTP.

export const EMAIL_NOT_VERIFIED_ERROR = "EMAIL_NOT_VERIFIED";
export const DEFAULT_RESEND_SECONDS = 60;

// 10-digit US number: area code and exchange can't start with 0 or 1.
export const US_PHONE_NUMBER_REGEX = /^[2-9]\d{2}[2-9]\d{6}$/;
export const US_PHONE_INVALID_MESSAGE = "Please enter a valid US phone number";

export const isValidUsPhoneNumber = (phoneNumber) =>
  US_PHONE_NUMBER_REGEX.test(String(phoneNumber || "").replace(/[^\d]/g, ""));

/**
 * Which verification screen comes next, from a signup / login /
 * verify-email response: "email", "phone", "login" or "done" (logged in).
 */
export const getNextVerificationStep = (data = {}) => {
  if (data?.authToken) return "done";
  if (data?.nextStep) return data.nextStep;
  if (data?.isEmailVerify === false) return "email";
  return "phone";
};

export const isEmailNotVerifiedError = (err) =>
  err?.error === EMAIL_NOT_VERIFIED_ERROR;

// Server messages about the phone number (US-only, VoIP / landline,
// duplicate) are shown on the phone field instead of the form.
export const isPhoneFieldError = (err) =>
  /phone number/i.test(err?.message || "");

export const formatResendTimer = (seconds) => {
  const s = Math.max(0, seconds);
  const mm = String(Math.floor(s / 60)).padStart(2, "0");
  const ss = String(s % 60).padStart(2, "0");
  return `${mm}:${ss}`;
};
